import { A11yRole } from "./a11y.role.enum";
import { A11yProperty } from "./a11y.property.enum";
import { A11yState } from "./a11y.state.enum";

export const ACCESSIBILITY = {
  ROLE: A11yRole,
  PROPERTIES: A11yProperty,
  STATES: A11yState
} as const;